// Hub signup A/B Experiment
export type ExperimentParams = "ob";

export const urlParamToExperimentVariantMap = {
  v1_su: "SIGN_UP_CONTROL",
  v2_su: "SIGN_UP_TEST",
} as const;

type ParamMap = typeof urlParamToExperimentVariantMap;
type Param = keyof ParamMap;
export type Variant = ParamMap[Param];

export const getExperimentVariantFromUrlParams = (
  param: ExperimentParams,
  searchParams: URLSearchParams
): Variant | undefined => {
  const isExperiment = searchParams.has(param);
  if (!isExperiment) return;

  const variant = searchParams.get(param);
  if (!variant) return;
  return urlParamToExperimentVariantMap[variant as Param];
};
